<template>
    <div class="unit-intro-panel">
        <custom-panel :title="title" :height="height" :moreText="'查看详情'" @moreClick="moreClickHandle">
            <template #content>
                <div class="intro-content">
                    <div class="left-content">
                        <p class="text" v-for="item in textList" :key="item">{{ item }}</p>
                    </div>
                    <div class="right-content">
                        <div class="img-content">
                            <a-spin :spinning="loading">
                                <a-carousel :autoplay="true">
                                    <img
                                        v-for="(img, idx) of imgList"
                                        :src="img"
                                        :key="idx"
                                        style="width: 350.4px; height: 248.4px"
                                    />
                                </a-carousel>
                            </a-spin>
                        </div>
                    </div>
                </div>
            </template>
        </custom-panel>
    </div>
</template>

<script>
import CustomPanel from '@/components/custom-panel.vue';
import { queryHomeImg } from '../../../common/api';

export default {
    props: {
        height: {
            type: Number
        }
    },

    components: {
        CustomPanel
    },

    data() {
        return {
            title: '单位介绍',
            currentContent: '',
            loading: false,
            textList: [
                '国家烟草质量监督检验中心（以下简称中心）为国家烟草专卖局下属的独立事业法人机构，是由国家烟草专卖局主管的国家级烟草及烟草制品专业检验检测机构。',
                '中心宗旨：为社会提供烟草质量监督检验服务和相应的能力验证活动。',
                '中心业务范围：烟草成分及释放物检验，国际实验室合作研究和方法验证，授权范围内烟草产品质量监督检验，国内销售或查获国内外卷烟产品、烟机、烟机零部件、烟叶和烟用材料鉴别与仲裁，新检测技术、方法研究开发。'
            ],
            imgList: []
        };
    },

    methods: {
        moreClickHandle() {
            this.$router.push('/unit-introduction');
        },

        async getImgList() {
            this.loading = true;
            const res = await queryHomeImg();
            this.imgList = res.data.map(item => item.fileUrl);
            this.loading = false;
        }
    },

    created() {
        this.getImgList();
    }
};
</script>

<style lang="scss" scoped>
.unit-intro-panel {
    .intro-content {
        display: flex;

        .left-content {
            width: 54%;
            margin: 2px 24px 0 8px;

            .text {
                font-family: PingFangSC-Regular;
                font-size: 16px;
                color: #333333;
                letter-spacing: 1px;
                text-align: justify;
                text-indent: 2em;
                line-height: 28px;
                font-weight: 400;
                margin-bottom: 8px;
            }
        }

        .right-content {
            flex: 1;
            position: relative;
            padding-top: 4px;
            // background: linear-gradient(90deg, #0267bd 4%, #0b5495 100%) no-repeat right bottom/149px 182px;

            .img-content {
                width: 354px;
                height: 255px;
                padding: 3.6px;
                background: #ffffff;
                box-shadow: 0px 2px 2px 1px rgba(0, 0, 0, 0.09);
            }
        }
    }
}
</style>
